/**
 * The referral fields a client save sends. On an existing client the referrer only changes through
 * the Change referrer dialog (which records a reason and decides what happens to earnings), so the
 * form always sends back what it loaded. On a new client it sends the pick, but only for someone
 * allowed to assign one.
 */
export const referrerFieldsForSave = ({ isNew, canAssign, data, original }) => {
  if (!isNew) {
    return {
      referral: original?.referral ?? "",
      referralPartnerId: original?.referralPartnerId ?? null,
      referralUserId: null,
      customReferral: !!original?.customReferral,
    };
  }
  if (!canAssign) {
    return { referral: "", referralPartnerId: null, referralUserId: null, customReferral: false };
  }
  return {
    referral: data?.referral ?? "",
    referralPartnerId: data?.referralPartnerId ?? null,
    referralUserId: data?.referralUserId ?? null,
    customReferral: !!data?.customReferral,
  };
};
